import CategoriesPage from "./CategoriesPage";

export default CategoriesPage;
